<template>
  <b-overlay :show="isLoading">
    <div class="row">
      <b-col cols="12">
        <b-button class="mb-2 float-right" @click="showAddModal = !showAddModal"
          >Add Custom Field</b-button
        >
        <br />
        <b-tabs content-class="mt-3" v-if="fieldData.fields.length">
          <b-tab title="Labels" active>
            <b-tabs pills card vertical>
              <!-- Render Tabs, supply a unique `key` to each tab -->
              <b-tab
                @click="tabClick(language)"
                v-for="(language, index) in form.formTranslations"
                :key="index"
                :title="language"
              >
                <!-- translation form wrappe -->
                <b-form-group :label="'Enter Label'">
                  <b-form-input
                    v-model="fieldData.label[language.toLowerCase()]"
                  ></b-form-input>
                </b-form-group>
                <div v-for="field in fieldData.fields" :key="field.id">
                  <b-form-group :label="'Enter Label for ' + field.name">
                    <b-form-input
                      v-model="field.label[language.toLowerCase()]"
                    ></b-form-input>
                  </b-form-group>
                  <!-- -------------------------------- -->
                  <div
                    v-if="
                      field.inputType == 'radio' ||
                        field.inputType == 'select' ||
                        field.inputType == 'checkbox'
                    "
                    class="mb-3"
                  >
                    <b-button @click="showOptionCollapse = !showOptionCollapse"
                      >Configured Options Text</b-button
                    >
                    <b-collapse v-model="showOptionCollapse">
                      <table class="table table-sm">
                        <thead>
                          <tr class="text-center">
                            <th>Option text</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(option, optionIndex) in field.options"
                            :key="optionIndex"
                          >
                            <td>
                              <b-form-group
                                label-cols-lg="2"
                                :label="'option ' + (optionIndex + 1)"
                              >
                                <b-form-input
                                  v-model="option.text[language.toLowerCase()]"
                                ></b-form-input>
                              </b-form-group>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-collapse>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-tab>
          <!-- helper texts ----------------------->
          <b-tab title="Helper Text">
            <b-tabs pills card vertical>
              <!-- Render Tabs, supply a unique `key` to each tab -->
              <b-tab
                @click="tabClick(language)"
                v-for="(language, index) in form.formTranslations"
                :key="index"
                :title="language"
              >
                <!-- translation form wrappe -->
                <div v-for="(field, index) in fieldData.fields" :key="index">
                  <b-form-group :label="'Enter Helper Text for ' + field.name">
                    <b-form-input
                      v-model="field.helper[language.toLowerCase()]"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-tab>
            </b-tabs>
          </b-tab>
          <!-- Place Holders ---------------->
          <b-tab title="Placeholders">
            <b-tabs pills card vertical>
              <!-- Render Tabs, supply a unique `key` to each tab -->
              <b-tab
                @click="tabClick(language)"
                v-for="(language, index) in form.formTranslations"
                :key="index"
                :title="language"
              >
                <!-- translation form wrappe -->
                <div v-for="(field, index) in fieldData.fields" :key="index">
                  <b-form-group :label="'Enter Placeholder for ' + field.name">
                    <b-form-input
                      v-model="field.placeholder[language.toLowerCase()]"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </b-tab>
            </b-tabs>
          </b-tab>

          <!-- data validation -->
          <b-tab title="Validation">
            <div class="text-left">
              <b-col>
                <div v-for="(field, index) in fieldData.fields" :key="index">
                  <b-form-checkbox
                    class="form-group col-md-6 ml-3"
                    value="1"
                    unchecked-value="0"
                    v-model="field.validation.required"
                    >is Required
                    {{ field.label[transalationLanguage] }}</b-form-checkbox
                  >
                </div>
              </b-col>
            </div>
          </b-tab>
          <!-- --------------Conditional------------------ -->
          <b-tab title="Conditional">
            <b-tabs pills card vertical>
              <!-- Render Tabs, supply a unique `key` to each tab -->
              <b-tab title="Simple">
                <b-col cols="12" class="mr-0">
                  <b-form-checkbox
                    v-model="isConditional"
                    name="conditional"
                    value="1"
                    unchecked-value="0"
                    >Is Conditional?</b-form-checkbox
                  >
                  <b-row v-if="isConditional == 1">
                    <b-col cols="1"> <br />1 </b-col>
                    <b-col cols="6">
                      <label class="text-left">When Field</label>
                      <v-select
                        v-model="conditionalField"
                        class="mb-2"
                        :options="conditionalSectionElementLables"
                        lablel="label"
                        @input="getSelectedElement"
                      ></v-select>
                    </b-col>
                    <b-col cols="5">
                      <label class="text-left">Has value</label>
                      <v-select
                        class="mb-2"
                        label="text"
                        v-model="conditionalFieldValue"
                        :options="selectedElementOption"
                      ></v-select>
                    </b-col>
                  </b-row>
                </b-col>
              </b-tab>
              <!-- <b-tab title="advanced"></b-tab> -->
            </b-tabs>
          </b-tab>
          <!-- ----------------Advance------------------->
          <b-tab title="Advanced">
            <b-form-checkbox
              class="text-left mb-3"
              value="1"
              unchecked-value="0"
              v-model="fieldData.isNaFeature"
              >Disable N/A Feature</b-form-checkbox
            >
          </b-tab>
        </b-tabs>
      </b-col>

      <b-modal
        cancel-title="Close"
        ok-title="Add"
        @ok="onAddField"
        v-model="showAddModal"
        @hidden="resetModal"
        scrollable
        size="lg"
        title=""
      >
        <b-form>
          <b-form-group>
            <v-select
              class="mb-5"
              :options="optionsFieldTypes"
              v-model="selectedFieldType"
              @input="checkForType"
              label="label"
              placeholder="Select"
            ></v-select>
          </b-form-group>
          <b-form-group
            v-if="selectedFieldType"
            label="Field Name (with no spaces e.g: firstName)"
          >
            <small>
              this will not be shown to the user, Please write this with no
              spaces you can use '-', '_' or camel case
            </small>
            <b-form-input
              placeholder="firstName, first-name or first_name"
              maxLength="15"
              v-model="fieldName"
            ></b-form-input>
          </b-form-group>
          <div v-if="showAddOption">
            <table class="table table-sm">
              <thead>
                <tr class="text-center">
                  <th>Option text</th>
                  <th>Value</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(option, optionIndex) in options" :key="optionIndex">
                  <td>
                    <b-form-input
                      v-model="option.text[transalationLanguage]"
                    ></b-form-input>
                  </td>
                  <td>
                    <b-form-input
                      :disabled="transalationLanguage !== 'english'"
                      v-model="option.value"
                    ></b-form-input>
                  </td>

                  <td>
                    <b-button
                      variant="outline-danger"
                      class="btn btn-outline-danger btn-sm"
                      @click="onDeleteOption(optionIndex)"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>

            <b-button variant="primary" @click="addOption">
              <i class="fa fa-plus"></i>
            </b-button>
          </div>
        </b-form>
        <b-list-group
          class="mt-2"
          v-for="(field, index) in fieldData.fields"
          :key="index"
        >
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            <span
              ><strong>Name: </strong>{{ field.name }}
              <strong class="ml-5">Type:</strong> {{ field.inputType }}</span
            >
            <b-button
              variant="outline-danger"
              size="sm"
              @click="onDeleteField(index)"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </b-list-group-item>
        </b-list-group>
      </b-modal>
    </div>
  </b-overlay>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/event-bus.js";
import vSelect from "vue-select";
import uid from "uid";
import _ from "lodash";

export default {
  name: "PrincipalContactSettings",
  props: {
    fieldData: Object,
    sectionIndex: Number,
    fieldIndex: Number,
  },
  components: {
    "v-select": vSelect,
  },

  data() {
    return {
      transalationLanguage: "english",

      conditionalSectionElements: [],
      conditionalSectionElementLables: [],
      selectedElementOption: [],
      conditionalField: null,
      conditionalFieldValue: null,
      isConditional: this.fieldData.isConditional,
      condition: {},

      showAddModal: false,
      selectedFieldType: null,
      showAddOption: false,
      isLoading: false,
      fieldName: null,
      showOptionCollapse: false,
      options: [
        {
          value: "No",
          text: {
            english: "No",
          },
          score: 0,
        },
        {
          value: "Yes",
          text: {
            english: "Yes",
          },
          score: 1,
        },
      ],
      optionsFieldTypes: [
        {
          key: "text",
          label: "Input Text",
        },
        {
          key: "email",
          label: "Input Email",
        },
        {
          key: "number",
          label: "Input Number",
        },
        {
          key: "date",
          label: "Date Picker",
        },
        {
          key: "select",
          label: "Select Box",
        },

        {
          key: "radio",
          label: "Radio",
        },
        {
          key: "checkbox",
          label: "Checkbox",
        },
        {
          key: "textarea",
          label: "Text Area",
        },
      ],
      elementdData: {
        id: uid(),
        name: null,
        inputType: null,
        postValue: null,
        value: null,
        options: [],
        label: {
          english: "",
        },
        placeholder: {
          english: "",
        },
        helper: {
          english: "",
        },
        validationMessage: {
          english: "",
        },
        conditionalFieldLabel: {
          english: "",
        },
        conditionalFieldHelperText: {
          english: "",
        },
        conditionalFieldPlaceHolderText: {
          english: "",
        },
        conditionalFieldValidationMessage: {
          english: "This field is required",
        },
        validation: {
          required: 1,
          disabled: 0,
        },
        isInValid: null,
        isHidden: false,
        conditions: [],
        conditionalFields: [],
        sectionConditions: [],
        enabledConditionalField: 0,
        conditionalShowHiddenOption: 0,
        conditionalFieldIsVisible: 0,
        selectedConditionalFieldValue: null,
        conditionalRadio: false,
        conditionalInput: false,
        selectedMutiInputs: 1,
        selectedMutiRadios: 1,
        conditionalFieldIsRequired: 0,
        conditionalFieldMinRows: 1,
        conditionalFieldMaxRows: 1,
        conditionalFieldInputValue: null,
        conditionalFieldPostName: null,
      },
    };
  },

  created() {
    EventBus.$on("onSaveSettings", (value) => {
      // this.updateAdvancedSettings();
      this.setFieldConditions();
    });
  },

  mounted() {
    this.getCurrentSectionList();
  },

  computed: {
    ...mapGetters({ form: "form1" }),
  },

  methods: {
    getCurrentSectionList() {
      let conditionalSectionElements = this.form.formSection[this.sectionIndex]
        .formElements;
      conditionalSectionElements = conditionalSectionElements.filter(
        (element, index) => {
          if (
            element.inputType === "radio" ||
            element.inputType === "checkbox" ||
            element.inputType === "select"
          ) {
            // return element
            let dd = {
              label: element.label[this.transalationLanguage],
              element,
            };
            return this.conditionalSectionElementLables.push(dd);
          }
        }
      );
      this.conditionalSectionElements = conditionalSectionElements;
      this.reRenderSavedConditions();
    },

    getSelectedElement(selectedElement) {
      this.selectedElementOption = [];
      this.conditionalFieldValue = null;
      if (selectedElement) {
        selectedElement.element.options.map((opt) => {
          this.selectedElementOption.push(opt.value);
        });
      }
    },

    reRenderSavedConditions() {
      if (this.fieldData.conditions && this.fieldData.conditions.length) {
        this.conditionalField = {
          label: this.fieldData.conditions[0].label,
          element: this.fieldData.conditions[0],
        };
        this.conditionalFieldValue = this.fieldData.conditions[0].value;
      }
    },

    setFieldConditions() {
      if (this.conditionalField && this.conditionalFieldValue) {
        let condition = {
          id: uid(),
          sourceFieldId: this.conditionalField.element.sourceFieldId
            ? this.conditionalField.element.sourceFieldId
            : this.conditionalField.element.id, //to where the condition is set, (radio, check, select)
          targetFieldId: this.fieldData.id, //from where the conditon is set
          value: this.conditionalFieldValue,
          label: this.conditionalField.label,
        };
        let elements = [...this.form.formSection[this.sectionIndex].formElements];
        elements = elements.map((element) => {
          if (element.options) {
            let found = element.options.map((opt) => {
              if (opt.value === this.conditionalFieldValue && this.conditionalField.element.id === element.id) {
                element.conditionalFields.push(condition);
              }
            });
          }
        });
        this.fieldData.isConditional = this.isConditional;
        this.fieldData.isHidden = true;
        // Object.assign(this.fieldData, { condition });
        this.fieldData.conditions = [];
        this.fieldData.conditions.push(condition);
        this.conditionalFieldValue = null;
        this.conditionalField = null;
      } else {
      }
    },

    checkForType(e) {
      if (e && (e.key == "radio" || e.key == "checkbox")) {
        this.showAddOption = true;
      } else {
        this.showAddOption = false;
      }
    },
    onAddField() {
      let fieldData = {};
      let elementdData = _.cloneDeep(this.elementdData);
      if (this.selectedFieldType && this.fieldName) {
        if (
          this.selectedFieldType.key == "radio" ||
          this.selectedFieldType.key == "checkbox"
        ) {
          fieldData = {
            ...elementdData,
            id: uid(),
            inputType: this.selectedFieldType.key,
            name: this.fieldName,
            options: this.options,
          };
        } else {
          fieldData = {
            ...elementdData,
            id: uid(),
            name: this.fieldName,
            inputType: this.selectedFieldType.key,
          };
        }
        if (fieldData.id && fieldData.inputType) {
          this.fieldData.fields.push(fieldData);
        }
      }
    },
    resetModal() {
      this.fieldName = null;
      this.selectedFieldType = null;
      this.showAddOption = false;
    },
    onDeleteField(index) {
      this.fieldData.fields.splice(this.fieldData.fields.indexOf(index), 1);
    },
    addOption() {
      let newOptiopn = {
        value: "Yes",
        text: {
          english: "Yes",
        },
      };
      this.options.push(newOptiopn);
    },

    onDeleteOption(index) {
      if (this.options.length > 2) {
        this.options.splice(this.options.indexOf(index), 1);
      }
    },
    tabClick(language) {
      let tempKey = language.toLowerCase();
    },
  },
};
</script>
<style>
.cursor {
  cursor: pointer;
}
</style>
